import React from 'react'
import { Container, Dropdown, Image, Segment, TextArea } from 'semantic-ui-react'

import edit from '../../assets/images/edit-small.png'
import { tr } from '../../helpers/languages'
import Rater from '../common/rater'

const Attendance = (props) => {
    const statuses = ['ontime', 'delayed', 'canceled', 'didntshow']
    const look = parseInt(props.session.appearance ? (props.session.appearance.look || 0) : 0, 10)
    return (
        <Container className='session-attendance'>
            <Segment className='section-title'>
                {tr('ATTENDANCE')}
                {
                    !props.editable && (
                        <Image src={edit} onClick={(_e) => { props.onToggleEditing() }}/>
                    )
                }
            </Segment>
            <Segment className='attendance-question'>
                {tr('DID_THE_PARTICIPANT_ATTEND_SESSION')} <span className='feelColor'>*</span>
            </Segment>
            <Segment className='attendance-status'>
                <Dropdown
                    fluid
                    selection
                    icon='angle down'
                    disabled={!props.editable}
                    placeholder={tr('SELECT_VALUE')}
                    options={
                        statuses.map((status) => {
                            return { value: status, text: tr(status.toUpperCase()) }
                        })
                    }
                    value={props.session.attendance ? props.session.attendance.status : ''}
                    onChange={(_e, { value }) => { props.onChangeValue('attendance.status', value) }}
                />
            </Segment>
            <Segment className='attendance-notes'>
                <TextArea
                    disabled={!props.editable}
                    placeholder={tr('ADDITIONAL_NOTES_ABOUT_ATTENDANCE')}
                    value={props.session.attendance ? props.session.attendance.notes : ''}
                    onChange={(e) => { props.onChangeValue('attendance.notes', e.target.value) }}
                    maxLength={300}
                />
            </Segment>
            <Segment className='appearance-question'>
                {tr('HOW_DID_THE_PARTICIPANT_LOOK')}
                {(props.session.attendance.status === 'ontime' || props.session.attendance.status === 'delayed') &&
                <span className='feelColor'> *</span>}
            </Segment>
            <Segment className='appearance-look'>
                <Rater
                    value={look}
                    onChangeValue={(value) => { props.onChangeValue('appearance.look', value.toString()) }}
                    editable={props.editable}
                />
            </Segment>
            <Segment className='appearance-notes'>
                <TextArea
                    disabled={!props.editable}
                    placeholder={tr('ADDITIONAL_NOTES_ABOUT_APPEARANCE')}
                    value={props.session.appearance ? props.session.appearance.notes : ''}
                    onChange={(e) => { props.onChangeValue('appearance.notes', e.target.value) }}
                    maxLength={300}
                />
            </Segment>
        </Container>
    )
}

export default Attendance



// WEBPACK FOOTER //
// ./src/components/participant-session/attendance.js